import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { getQueriedFluidImage } from "../../CMSImage";

const GatsbyImageComp = ({ imageAlt, image, localImg = false, className }) => {
  return (
    <>
      {localImg ? (
        <img
          className={className}
          src={getImage(getQueriedFluidImage(image))?.images?.fallback.src}
          alt={
            imageAlt
              ? typeof imageAlt === "string"
                ? imageAlt.replace(/<\/?p>/g, "")
                : imageAlt.image_alt && imageAlt.image_alt !== ""
                ? imageAlt.image_alt.replace(/<\/?p>/g, "")
                : imageAlt.data &&
                  imageAlt.data.image_alt &&
                  imageAlt.data.image_alt !== ""
                ? imageAlt.data.image_alt.replace(/<\/?p>/g, "")
                : "image"
              : "image"
          }
        />
      ) : (
        <GatsbyImage
          className={className}
          image={getImage(getQueriedFluidImage(image))}
          alt={
            imageAlt
              ? typeof imageAlt === "string"
                ? imageAlt.replace(/<\/?p>/g, "")
                : imageAlt.image_alt && imageAlt.image_alt !== ""
                ? imageAlt.image_alt.replace(/<\/?p>/g, "")
                : imageAlt.data &&
                  imageAlt.data.image_alt &&
                  imageAlt.data.image_alt !== ""
                ? imageAlt.data.image_alt.replace(/<\/?p>/g, "")
                : "image"
              : "image"
          }
        />
      )}
    </>
  );
};

export default GatsbyImageComp;
